// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { ClientOnboarderService } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/ClientOnboarder';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorBasedQuery } from '../../useOperatorBasedQuery';

const useClientOnboarderServices: () => UseQueryResult<
  TemplateContract<ClientOnboarderService>[],
  string
> = () =>
  useOperatorBasedQuery('queryClientOnboarderServices', (ledgerApi, offset, operator) =>
    ledgerApi.queryClientOnboarderServices(offset, operator),
  );

export default useClientOnboarderServices;
